import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from 'app/shared/apis/api.service';
import { of, switchMap, take } from 'rxjs';

export const AdminGuard: CanActivateFn = () => {
    const router = inject(Router);

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user) => {
            if (user?.is_admin) {
                return of(true);
            }

            return of(router.parseUrl('/home'));
        }),
    );
};
